export default function UkrailResultsBaseController(
    $scope,
    cfg,
    flightsFactory,
    $state,
    $stateParams
) {
    'ngInject';

    $scope.showUkrailResults = function() {
        $state.go(cfg.resultsRoute, {
            DomesticSearchGUId: $stateParams.RailSearchId,
            FlightType: flightsFactory.params.flightType,
        });
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/flights/ukrailResultsBaseCtrl.js